import React, { useState } from 'react';
import {  NavLink } from "react-router-dom";
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const number = new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' })
const decimal = new Intl.NumberFormat('es-CL', { style: 'decimal', maximumFractionDigits:2 })

export default function Paso3(props) {

    const { data } = props
    const { simulacion } = data
    const toastId = React.useRef(null);
    const [ spinner, setSpinner ] = useState(false);

    if(!props || !data || !simulacion) {
        window.location.href=process.env.REACT_APP_URL;
    }
    const newSimulation = () => {
        window.grecaptcha.ready(async function() {
            window.grecaptcha.execute(process.env.REACT_APP_RECAPTCHA_KEY, {action: 'submit'}).then(async function(captchaToken) {
                const localToken = localStorage.getItem('token')
    
                const options = {
                    headers: {
                        'Content-Type': 'application/json',
                        'token': localToken,
                        'captchatoken': captchaToken
                    }
                };
                try {
                    console.log('aca....')
                    const { data: data_resp } = await axios.post(process.env.REACT_APP_URL_API+process.env.REACT_APP_NEW_SIMULATION, JSON.stringify(data), options)
                    if(!data_resp.token ){
                        if(! toast.isActive(toastId.current)) {
                            toast.error( ('Ocurrió un error, inténtelo nuevamente por favor.'), {
                                position: "top-center",
                                autoClose: false,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                });
                        }
                    } else {
                      localStorage.setItem('token', data_resp.token)
                      window.location.href = process.env.REACT_APP_URL;
                    }
                
                } catch(e){
                  localStorage.clear('token')
                   window.location.href = process.env.REACT_APP_URL;
                }
            });
          });
    }


    const downloadSimulation = () => {
        setSpinner(true)

        window.grecaptcha.ready(async function() {
            window.grecaptcha.execute(process.env.REACT_APP_RECAPTCHA_KEY, {action: 'submit'}).then(async function(captchaToken) {
                const localToken = localStorage.getItem('token')
    
                const options = {
                    headers: {
                        'Content-Type': 'application/json',
                        'token': localToken,
                        'captchatoken': captchaToken,
                        'responseType': 'blob'
                    }
                };
                try {
                    const { data: data_resp } = await axios.post(process.env.REACT_APP_URL_API+process.env.REACT_APP_DOWNLOAD_SIMULATION,
                                                                JSON.stringify(data), 
                                                                options)
                    setSpinner(false)
                    window.location=`${process.env.REACT_APP_URL_API}${data_resp.uri}`;
                } catch(e){
                    localStorage.clear('token')
                    window.location.href='';
                    setSpinner(false)
                }
            });
          });
    }
    
    return (
        
      <div>    {spinner &&  <div className="loading">
      <div className="uil-ring-css">
          <div></div>
      </div>
      </div>
  }
            <ToastContainer
            position="top-center"
            autoClose={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            />
            <div>
                <div className="proceso">
                    <div className="line">
                        <hr />
                    </div>
                    <div className="linea-pasos">
                        <div className="center">
                            {/* <a className="paso-active" href="index.html">1</a> */}
                            <NavLink className="paso-active" activeClassName="paso-active" to="/">1</NavLink>
                            <p>DATOS PERSONALES</p>
                        </div>
                        <div className="center">
                            {/* <a className="paso" href="montos.html">2</a> */}
                            <NavLink className="paso-active" to="/">2</NavLink>
                            <p>MONTO Y PLAZO</p>
                        </div>
                        <div className="center">
                            {/* <a className="paso" href="simulacion.html">3</a> */}
                            <NavLink className="paso-active" to="/">3</NavLink>
                            <p>SIMULACIÓN</p>
                        </div>
                    </div>    
                    </div>
            </div>  
          <div className="campos">
                <div className="linea">

                    <div className="container">
                        <div className="linea-interna separador">
                            <div className="container">
                                <p>Monto Líquido</p>
                            </div>
                            <div className="container right">
                                <p>{number.format(simulacion.monto_liquido)}</p>
                            </div>
                        </div>
                        <div className="linea-interna separador">
                            <div className="container">
                                <p>Gastos notariales</p>
                            </div>
                            <div className="container right">
                            <p>{number.format(simulacion.gastos_notariales)}</p>
                            </div>
                        </div>
                        <div className="linea-interna separador">
                            <div className="container">
                                <p>Impuesto</p>
                            </div>
                            <div className="container right">
                            <p>{number.format(simulacion.impuesto)}</p>
                            </div>
                        </div>
                        <div className="linea-interna separador">
                            <div className="container">
                                <p>Seguro de Desgravamen</p>
                            </div>
                            <div className="container right">
                            <p>{number.format(simulacion.seguro_desgravamen)}</p>
                            </div>
                        </div>
                        <div className="linea-interna separador">
                            <div className="container">
                                <p>Monto Bruto</p>
                            </div>
                            <div className="container right">
                            <p>{number.format(simulacion.monto_bruto)}</p>
                            </div>
                        </div>
                    </div>

                    <div className="container">
                        <div className="linea-interna separador">
                            <div className="container">
                                <p>Tasa de Interés Vigente</p>
                            </div>
                            <div className="container right">
                            <p>{decimal.format(simulacion.tasa_anual)} %</p>
                            </div>
                        </div>
                        <div className="linea-interna">
                            <div className="container">
                                <p>Estimación de Intereses Devengados</p>
                            </div>
                            <div className="container right">
                            <p>{number.format(simulacion.estimacion_interes_devengado||0)}</p>
                            </div>
                        </div>
                        <div className="linea-interna resultado">
                            <div className="container">
                                <p>Monto a Pagar Estimado</p>
                            </div>
                            <div className="container right">
                            <p>{number.format(simulacion.monto_pagar)}</p>
                            </div>
                        </div>
                        <div className="linea-interna">
                            <div className="container">
                                <p>CAE (Carga Anual Equivalente)</p>
                            </div>
                            <div className="container right">
                            <p>{decimal.format(simulacion.cae)}%</p>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
        <div className="descarga-simulacion">
            <p>La simulación ha sido enviada a la casilla de correo electrónico proporcionada. 
            </p>
            <p></a></p>
                <div className="boton">
                    <button onClick={newSimulation} type="submit">VOLVER A SIMULAR</button>
                </div>
        </div>
        
        <div className="texto-legal">
            <p>El monto a pagar estimado es meramente referencial. Se ha calculado considerando la aplicación de la tasa de interés vigente al monto bruto por el cual se emite esta simulación, la cual tiene carácter informativo y no constituye aprobación del préstamo por parte de Mutual de Seguros de Chile. Dicha tasa corresponde a la vigente a la fecha de simulación, la cual podría variar al momento de la solicitud.<br /><br />Al momento de la solicitud, Mutual de Seguros de Chile realiza una evaluación de los antecedentes financieros, los cuales deben cumplir los estándares de riesgo de crédito establecidos por la Corporación. Para solicitudes de préstamos de desahucio contactar a prestamosdesahucio@mutualdeseguros.cl 
            </p>
        </div>
      </div>
    )
  }